/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_scatter_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a scatter plot from X,Y data — reveal correlations, no sign-up.`)
};

const es_scatter_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un diagrama de dispersión a partir de datos X,Y — revela correlaciones, sin registro.`)
};

const de_scatter_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen Sie ein Streudiagramm aus X,Y-Daten — decken Sie Korrelationen auf, keine Anmeldung erforderlich.`)
};

const nl_scatter_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak een spreidingsdiagram van X,Y-data — onthul correlaties, geen registratie nodig.`)
};

const fr_scatter_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez un nuage de points à partir de données X,Y — révélez les corrélations, sans inscription.`)
};

const it_scatter_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un grafico a dispersione da dati X,Y — rivela correlazioni, senza registrazione.`)
};

const pt_br2_scatter_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um gráfico de dispersão a partir de dados X,Y — revele correlações, sem cadastro.`)
};

const pt_scatter_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um gráfico de dispersão a partir de dados X,Y — revele correlações, sem registo.`)
};

const ja_scatter_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`X, Yデータから散布図を作成します — 相関関係を明らかにする、登録不要。`)
};

const zh_scatter_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据 X,Y 数据创建散点图——揭示相关性，无需注册。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const scatter_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.scatter_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("scatter_tool_description", locale)
	if (locale === "en") return en_scatter_tool_description(inputs)
	if (locale === "es") return es_scatter_tool_description(inputs)
	if (locale === "de") return de_scatter_tool_description(inputs)
	if (locale === "nl") return nl_scatter_tool_description(inputs)
	if (locale === "fr") return fr_scatter_tool_description(inputs)
	if (locale === "it") return it_scatter_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_scatter_tool_description(inputs)
	if (locale === "pt") return pt_scatter_tool_description(inputs)
	if (locale === "ja") return ja_scatter_tool_description(inputs)
	return zh_scatter_tool_description(inputs)
};